/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import replaceSettingsMsg from "utils/replace-settings-msg";
import checkCircle from "assets/check-circle.svg";
import errorCircle from "assets/error-circle.svg";
import { Container, Text } from "components/common";
import SettingsButton from "../common/SettingsButton";
import SettingsInputContainer from "../common/SettingsInputContainer";

const SettingsItemDesktop = ({
  title,
  summary,
  Component,
  accessor,
  user,
  initiallyExpanded,
  isRiskLocked,
  canExpand = true,
  roles,
}) => {
  const [expanded, setExpanded] = useState(initiallyExpanded);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  const myRef = useRef();

  const renderSettingsMsg = () =>
    replaceSettingsMsg(summary, accessor, user, { isRiskLocked }).map(
      ({ text, isBold }) => (
        <p key={text} className={classnames("mr-1", { "font-bold": isBold })}>
          {text}
        </p>
      )
    );

  useEffect(() => {
    if (expanded) {
      setTimeout(() => myRef?.current?.scrollIntoView({ behavior: 'smooth' }), 750);
    }
  }, []);

  return (
    <Container
      paddingVertical={6}
      className="mb-2 px-6"
      heightFull={false}
      id={title.toLowerCase().replace(/ /g, "-")}
    >
      <div
        className={`flex justify-between py-4 ${
          canExpand && " cursor-pointer"
        }`}
        onClick={canExpand && (() => setExpanded(!expanded))}
      >
        <div className="self-center">
          <Text className="font-bold text-lg font-title">{title}</Text>
          <div className="mt-2 flex items-center flex-wrap">
            {expanded &&
              ((updateSuccess && (
                <>
                  <img
                    alt="success"
                    className="mr-1"
                    style={{ height: "20px" }}
                    src={checkCircle}
                  />
                  <div className="mr-1">Update Successful.</div>
                </>
              )) ||
                (updateError && (
                  <>
                    <img
                      alt="error"
                      className="mr-1"
                      style={{ height: "20px" }}
                      src={errorCircle}
                    />
                    <div className="mr-1">Update unsuccessful.</div>
                  </>
                )))}
            {expanded
              ? !updateError && renderSettingsMsg()
              : renderSettingsMsg()}
          </div>
        </div>
        <div>
          {canExpand && expanded ? (
            <i className="fa-solid fa-chevron-up" />
          ) : (
            <i className="fa-solid fa-chevron-down" />
          )}
        </div>
      </div>
      {expanded && (
        <div>
          <Component
            user={user}
            roles={roles}
            isRiskLocked={isRiskLocked}
            SettingsButton={SettingsButton((response = {}) => {
              if (response.success) {
                setUpdateSuccess(true);
                setUpdateError(false);
              } else {
                setUpdateSuccess(false);
                setUpdateError(true);
              }
            })}
            resetSuccess={() => {
              setUpdateSuccess(false);
            }}
            setSuccess={() => {
              setUpdateSuccess(true);
              setUpdateError(false);
            }}
            setError={(error) => {
              setUpdateError(error);
              setUpdateSuccess(false);
            }}
            SettingsInputContainer={SettingsInputContainer}
          />
          <div ref={myRef} />
        </div>
      )}
    </Container>
  );
};

SettingsItemDesktop.defaultProps = {
  summary: "",
};

export default SettingsItemDesktop;
